import { Redirect } from "react-router-dom";

export default function RedirectPage() {
  const requirements = localStorage.getItem("@req");

  if (requirements === "true") {
    return <Redirect to="/personal_data" />;
  } else {
    return <Redirect to="/not_meet_requirements" />;
  }
}
